<template>
  <div v-if="$store.getters.loading"></div>
  <div v-else>
    <DataTable :headers="headers" :path="path" :filterPath="filterPath" :properties="properties"
               :action-buttons-name="actionButtonsName" filter toolbar slot-name="second-last-column"
               :toolbar-title="tituloTabla" :search-text="searchText">
      <template slot="before-filters">
        <v-btn color="primary" @click="showCondicionesDialog" v-if="canAddCondiciones">Importar Condiciones</v-btn>
      </template>
      <template slot="second-last-column" slot-scope="props">
        <template v-if="noContracts(props.item)">
          <td v-if="$store.getters.isSafRole" colspan="6" class="text-xs-center table-row-no-contracts custom-font-regular" :key="'row'">No tiene contratos</td>
          <td v-else colspan="4" class="text-xs-center table-row-no-contracts custom-font-regular" :key="'row'">No tiene contratos</td>
        </template>
        <template v-else>
          <td class="text-xs-center table-row" :key="'row-1'">
            <v-chip small text-color="white" color="green lighten-2">{{ props.item.verified }}</v-chip>
          </td>
          <td class="text-xs-center table-row" :key="'row-2'">
            <v-chip small text-color="grey darken-2" color="yellow">{{ props.item.pending }}</v-chip>
          </td>
          <td class="text-xs-center table-row" :key="'row-3'">
            <v-chip small text-color="white" color="red lighten-1">{{ props.item.rejected }}</v-chip>
          </td>
          <td class="text-xs-center table-row" :key="'row-4'">
            <v-chip small text-color="white" color="grey lighten-1">{{ props.item.ended }}</v-chip>
          </td>
          <td class="text-xs-center table-row" :key="'row-5'" v-if="canViewCondition">
            <v-chip small text-color="white" color="blue lighten-1">{{ props.item.condiciones }}</v-chip>
          </td>
          <td
          v-if="$store.getters.isSafRole && !cuerpoTecnico"
          class="text-xs-center table-row table-row-salary-condition-afa" :key="'row-6'">
            <v-chip v-if="props.item.afaContractsSalaryConditions == 'Sin cargar'" small text-color="white" color="red lighten-1">{{ props.item.afaContractsSalaryConditions }}</v-chip>
            <v-chip v-if="props.item.afaContractsSalaryConditions == 'Cargadas'" small text-color="white" color="blue lighten-1">{{ props.item.afaContractsSalaryConditions }}</v-chip>
            <p v-if="props.item.afaContractsSalaryConditions == '-'">{{props.item.afaContractsSalaryConditions}}</p>
          </td>
        </template>
      </template>
    </DataTable>
    <CondicionesImportPopup ref="condicionesPopup"></CondicionesImportPopup>
  </div>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'
import CondicionesImportPopup from '../../condicion_salarial/components/CondicionesImportPopup'

export default {
  components: {
    DataTable,
    CondicionesImportPopup
  },
  props: {
    path: String,
    filterPath: String,
    actionButtonsName: String,
    tituloTabla: String,
    cuerpoTecnico: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    headers () {
      let headers = [
        { text: 'Apellido', value: 'last_name' },
        { text: 'Nombre', value: 'first_name' },
        { text: 'Estado', value: 'player_status', sortable: false, filterField: true },
        { text: 'Estado Contractual', value: 'contractual_status', filterField: true, visible: false },
        { text: 'Verificados', value: 'verified', sortable: false },
        { text: 'Pendientes', value: 'pending', sortable: false },
        { text: 'Rechazados', value: 'rejected', sortable: false },
        { text: 'Finalizados', value: 'ended', sortable: false },
        { text: 'Acciones', align: 'right', sortable: false }
      ]
      if (this.$store.getters.isSafRole) {
        headers.splice(3, 0, { text: 'Club', value: 'club', filterField: true })
        if (!this.cuerpoTecnico) {
          headers.splice(9, 0, { text: 'Cond. salariales AFA',
            value: 'afa_contracts_salary_conditions',
            sortable: false,
            filterField: true }
          )
        }
      }
      if (this.canViewCondition) {
        headers.splice(9, 0, { text: 'Cond. Salariales', value: 'condiciones' })
      }
      if (this.cuerpoTecnico) {
        headers.splice(3, 0, { text: 'Rol', value: 'rol' })
      }
      return headers
    },
    canAddCondiciones () {
      return this.$store.state.permissions.canAddConditions
    },
    properties () {
      let properties = ['player.lastName', 'player.firstName', 'status']
      if (this.$store.getters.isSafRole) {
        properties.splice(3, 0, 'club.nombre')
      }
      if (this.cuerpoTecnico) {
        properties.splice(3, 0, 'rol')
      }
      return properties
    },
    canViewCondition () {
      return this.$store.state.permissions.canViewConditions && this.$store.getters.isSafRole
    },
    searchText () {
      return this.cuerpoTecnico ? 'Buscar por nombre o apellido de miembro del cuerpo técnico' : 'Buscar por nombre o apellido de jugador'
    }

  },

  methods: {
    showCondicionesDialog () {
      this.$refs.condicionesPopup.showDialog()
    },
    noContracts (item) {
      return (item.verified + item.pending + item.rejected + item.ended) === 0
    }
  }
}
</script>

<style scoped>
.table-row {
  background-color: white;
  border-bottom: 1px solid #959ba6;
}
.table-row-no-contracts {
  background-color: #d0caca;
  border-bottom: 1px solid #959ba6;
}
</style>
